import React, { Component } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { Switch, Route, Redirect } from "react-router-dom";

import RadioOperatorCertificateDetails from "./RadioOperatorCertificateDetails";
import AddVessel from "./AddVessel";
import AddEmergencyContactDetails from "./AddEmergencyContactDetails";
import EmergencyContactsList from "./EmergencyContactsList";
import VesselEquipmentDetails from "./VesselEquipmentDetails";
import AddVesselEquipment from "./AddVesselEquipment";
import AddEpirb from "./AddEpirbDetails";
import EpirbList from "./EpirbDetailsList";
import ReviewAndDeclarations from "./ReviewAndDeclarations";
import MakePayment from "./MakePayment";
import PaymentConfirmationPage from "./PaymentConfirmationPage";
import PaymentFailedPage from "./PaymentFailedPage";
import LicenceNotes from "./LicenceNotes";

import CreateGetLicenceApplicationByIdAction from "../store/actionCreators/CreateGetLicenceApplicationByIdAction";
import CreateGetRequiredEpirbAction from "../store/actionCreators/CreateGetRequiredEpirbAction";
import CreateGetLicenceImagesAction from "../store/actionCreators/CreateGetLicenceImagesByLicenceIdAction";
import CreateGetVesselImagesAction from "../store/actionCreators/CreateGetVesselImagesByLicenceIdAction";
import CreateGetLicenceNotesAction from "../store/actionCreators/CreateGetLicenceNotesAction";

// Helper to wrap components with route props and parentRoute
const wrapWithRouteProps = (Component, extraProps = {}) => (props) =>
    <Component {...props} {...extraProps} />;

// Route configuration array
const routeConfig = [
    { path: "/apply", component: RadioOperatorCertificateDetails, exact: true },
    { path: "/apply/licence/:id?", component: RadioOperatorCertificateDetails },
    { path: "/apply/add-vessel/:id?", component: AddVessel },
    { path: "/apply/add-emergency-contact/:id?", component: AddEmergencyContactDetails },
    { path: "/apply/emergency-contacts-list/:id?", component: EmergencyContactsList },
    { path: "/apply/vessel-equipment-details/:id?", component: VesselEquipmentDetails },
    { path: "/apply/add-vessel-equipment/:id?", component: AddVesselEquipment },
    { path: "/apply/add-epirb/:id?", component: AddEpirb },
    { path: "/apply/epirb-list/:id?", component: EpirbList },
    { path: "/apply/review-declarations/:id?", component: ReviewAndDeclarations },
    { path: "/apply/notes/:id?", component: LicenceNotes },
    { path: "/apply/make-payment/:id?", component: MakePayment },
    { path: "/apply/payment-success/:id?", component: PaymentConfirmationPage },
    { path: "/apply/payment-failed/:id?", component: PaymentFailedPage },
];

class ApplyRoutes extends Component {

    componentDidMount() {
        const id = this.props.location.pathname.substring(this.props.location.pathname.lastIndexOf('/') + 1);
        const urlId = isNaN(id) ? 0 : Number(id);
        if (urlId !== 0) {
            this.props.getLicenceApplication(urlId);
        }
    }

    render() {
        if (this.props.hasAccess != null && !this.props.hasAccess) {
            return <Redirect to="/no-access" />;
        }

        return (
            <Switch>
                {routeConfig.map(({ path, component, exact }) => (
                    <Route
                        key={path}
                        path={path}
                        exact={exact}
                        render={wrapWithRouteProps(component, { parentRoute: "/apply" })}
                    />
                ))}
            </Switch>
        );
    }
}

// Redux connection
const mapStateToProps = (state) => ({
    hasAccess: state.hasAccess,
});

const mapDispatchToProps = (dispatch) => ({
    getLicenceApplication: (applicationId) => {
        dispatch(CreateGetLicenceApplicationByIdAction(applicationId));
        dispatch(CreateGetRequiredEpirbAction(applicationId));
        dispatch(CreateGetLicenceImagesAction(applicationId));
        dispatch(CreateGetVesselImagesAction(applicationId, false));
        dispatch(CreateGetLicenceNotesAction(applicationId));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ApplyRoutes));